// 导入组件
import Vue from 'vue'
import Router from 'vue-router'

// 启用路由
Vue.use(Router)

// 导出路由
export default new Router({
  routes: [
    {
      path: '/',
      name: '桦德时代',
      component: () => import('../views/www.vue'),
      hidden: true,
      meta: {
        requireAuth: false
      }
    }, {
      path: '/manage/login',
      name: '登录(管理端)',
      component: () => import('../views/manage/login.vue'),
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/manage/index',
      name: '首页',
      component: () => import('../views/manage/index.vue'),
      iconCls: 'el-icon-tickets',
      children: [
        {
          path: '/manage/account/info',
          name: '帐号信息',
          component: () => import('../views/manage/account/info.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/saleNote/find',
          name: '销售单列表',
          component: () => import('../views/manage/saleNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/area/find',
          name: '地区管理',
          component: () => import('../views/manage/area/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/shop/find',
          name: '经销商管理',
          component: () => import('../views/manage/shop/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/member/find',
          name: '会员管理',
          component: () => import('../views/manage/member/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/goods/find',
          name: '产品管理',
          component: () => import('../views/manage/goods/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/user/find',
          name: '用户管理',
          component: () => import('../views/manage/user/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/salePoint/find',
          name: '积分管理',
          component: () => import('../views/manage/salePoint/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/purchaseNote/find',
          name: '订货单管理',
          component: () => import('../views/manage/purchaseNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/variable/find',
          name: '系统参数管理',
          component: () => import('../views/manage/variable/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/sellPointList/find',
          name: '会员积分情况',
          component: () => import('../views/manage/sellPointList/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/pointExchangeNote/find',
          name: '积分兑换情况',
          component: () => import('../views/manage/pointExchangeNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/memberExchangeNote/find',
          name: '会员续费管理',
          component: () => import('../views/manage/memberExchangeNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/losePointList/find',
          name: '免付积分',
          component: () => import('../views/manage/losePointList/find.vue'),
          meta: {
            requireAuth: true
          }
        }
      ]
    },
    {
      path: '/shop/login',
      name: '登录',
      component: () => import('../views/shop/login.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/shop/index',
      name: '首页',
      component: () => import('../views/shop/index.vue'),
      iconCls: 'el-icon-tickets',
      children: [
        {
          path: '/shop/saleNote/find',
          name: '销售单管理',
          component: () => import('../views/shop/saleNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/pointExchangeNote/find',
          name: '积分兑换管理',
          component: () => import('../views/shop/pointExchangeNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/pointExchangeNoteV2/find',
          name: '积分兑换管理',
          component: () => import('../views/shop/pointExchangeNoteV2/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/shop/find',
          name: '经销商管理',
          component: () => import('../views/shop/shop/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/member/find',
          name: '会员管理',
          component: () => import('../views/shop/member/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/shopChild/find',
          name: '分销管理',
          component: () => import('../views/shop/shopChild/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/goods/find',
          name: '产品管理',
          component: () => import('../views/shop/goods/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/user/find',
          name: '用户管理',
          component: () => import('../views/shop/user/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/sellPointList/find',
          name: '会员积分明细',
          component: () => import('../views/shop/sellPointList/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/purchaseNote/find',
          name: '订货单管理',
          component: () => import('../views/shop/purchaseNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/variable/find',
          name: '系统参数管理',
          component: () => import('../views/shop/variable/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/member/promotion',
          name: '推荐码',
          component: () => import('../views/shop/member/promotion.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/inventory/find',
          name: '库存查询',
          component: () => import('../views/shop/inventory/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/inventoryExchangeNote/find',
          name: '库存调拨',
          component: () => import('../views/shop/inventoryExchangeNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/purchaseNote/findDo',
          name: '供货处理',
          component: () => import('../views/shop/purchaseNote/findDo.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/inventoryExchangeNote/find',
          name: '库存调拨',
          component: () => import('../views/shop/inventoryExchangeNote/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/shopPoint/find',
          name: '推广积分查询',
          component: () => import('../views/shop/shopPoint/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/report/sale',
          name: '销售月度报表',
          component: () => import('../views/shop/report/sale.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/report/goods',
          name: '产品销量报表',
          component: () => import('../views/shop/report/goods.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/report/member',
          name: '会员新增报表',
          component: () => import('../views/shop/report/member.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/report/purchase',
          name: '订货月度报表',
          component: () => import('../views/shop/report/purchase.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/inventoryOrder/find',
          name: '入库单管理',
          component: () => import('../views/shop/inventoryOrder/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/inventoryOrder/in/find',
          name: '入库单管理',
          component: () => import('../views/shop/inventoryOrder/in/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/inventoryOrder/out/find',
          name: '出库单管理',
          component: () => import('../views/shop/inventoryOrder/out/find.vue'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/shop/report/libLog',
          name: '仓库月度报表',
          component: () => import('../views/shop/report/libLog.vue'),
          meta: {
            requireAuth: true
          }
        }
      ]
    },
    {
      path: '/wx/member/register',
      name: '注册',
      component: () => import('../views/wx/member/register.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/member/registerOk',
      name: '注册成功',
      component: () => import('../views/wx/member/registerOk.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/info',
      name: '我的',
      component: () => import('../views/wx/info.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/member/promotion',
      name: '推荐码',
      component: () => import('../views/wx/member/promotion.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/pointExchangeNote/new',
      name: '积分兑换录入',
      component: () => import('../views/wx/pointExchangeNote/new.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/pointExchangeNote/new2',
      name: '积分兑换录入',
      component: () => import('../views/wx/pointExchangeNote/new2.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/memberExchangeNote/new',
      name: '会员充值',
      component: () => import('../views/wx/memberExchangeNote/new.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/memberExchangeNote/newOk',
      name: '会员充值成功',
      component: () => import('../views/wx/memberExchangeNote/newOk.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/memberExchangeNote/newFail',
      name: '会员充值失败',
      component: () => import('../views/wx/memberExchangeNote/newFail.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/member/sign',
      name: '会员银行签约',
      component: () => import('../views/wx/member/sign.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/memberExchangeNote/list',
      name: '会员充值历史',
      component: () => import('../views/wx/memberExchangeNote/list.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/pointExchangeNote/list',
      name: '积分兑换历史',
      component: () => import('../views/wx/pointExchangeNote/list.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/projectInfo/new',
      name: '申请项目',
      component: () => import('../views/wx/projectInfo/new.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/help/help',
      name: '点赞',
      component: () => import('../views/wx/help/help.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/help/helpResult',
      name: '点赞单据',
      component: () => import('../views/wx/help/helpResult.vue'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wx/saleNote/new',
      name: '在线下单',
      component: () => import('../views/wx/saleNote/new.vue'),
      meta: {
        requireAuth: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js